import $ from 'jquery';

const $body = $( 'body' );
const $categoryPreviews = $( '.categoryPreview' );
const $navFilter = $( '#js-navFilter' ).find( 'li > a' );
const $navBar = $( '#navBar' );
const $siteHeader = $( '#site-header' );
const $slider = $( '.slider > .slides' );
let crossfadePreviews = false;

function getHashFilter() {
	const matches = window.location.hash.match( /filter=([^&]+)/i );
	const hashFilter = matches && matches[1];
	return hashFilter && decodeURIComponent( hashFilter );
}

function updateHash( $filter ) {
	const filterAttr = $filter.attr( 'data-filter' );
	const filterHash = `filter=${encodeURIComponent( filterAttr )}`;

	window.location.hash = filterHash;
}

function updateNavFilters( category ) {
	$navFilter.each( ( index, el ) => {
		if ( $( el ).hasClass( 'is-active' ) ) {
			$( el ).removeClass( 'is-active' );
		} else if ( $( el ).attr( 'data-filter' ) === category ) {
			$( el ).addClass( 'is-active' );
		}
	} );
}

function fadeInActivePreview( category ) {
	$categoryPreviews.each( ( index, el ) => {
		if ( $( el ).attr( 'data-category' ) === category ) {
			$( el ).css( 'display', 'flex' ).hide().fadeIn( 'slow' );
		}
	} );
}

function fadeOutOldPreview( category ) {
	$categoryPreviews.each( ( index, el ) => {
		if ( $( el ).is( ':visible' ) ) {
			$( el ).fadeOut( () => {
				fadeInActivePreview( category );
			} );
		}
	} );
}

function showActivePreview( category ) {
	$categoryPreviews.each( ( index, el ) => {
		if ( $( el ).attr( 'data-category' ) === category ) {
			$( el ).css( 'display', 'flex' );
		} else {
			$( el ).css( 'display', 'none' );
		}
	} );
}

function updateSlider( category ) {
	const currentCategoryPreview = $( `.categoryPreview[data-category=${category}]` );
	const slideIndex = $categoryPreviews.index( currentCategoryPreview );

	$slider.cycle( 'goto', slideIndex );
}

function updateCategory() {
	const category = getHashFilter();

	if ( crossfadePreviews ) {
		fadeOutOldPreview( category );
	} else {
		showActivePreview( category );
	}

	updateSlider( category );
	updateNavFilters( category );
}

function closeNav() {
	const $hamburger = $( '#hamburger' );
	const $navCanvas = $( '#navCanvas' );

	if ( $navBar.hasClass( 'is-open' ) ) {
		$navBar.removeClass( 'is-open' );
		$hamburger.attr( 'aria-expanded', 'false' );
		$navCanvas.attr( 'aria-hidden', 'true' );
	}
}

function scrollToPreviews( speed ) {
	$( 'html, body' ).animate( {
		scrollTop: $( '#main' ).offset().top - $siteHeader.outerHeight(),
	}, speed );
}

function initEvents() {
	$body.on( 'click', 'a[data-filter]', ( e ) => {
		if ( $( 'body' ).hasClass( 'is-page-front' ) ) {
			e.preventDefault();
		}

		closeNav();
		scrollToPreviews( 'slow' );
		updateHash( $( e.currentTarget ) );
		if ( $( e.currentTarget ).closest( 'ul' ).hasClass( 'navMain' ) ) {
			crossfadePreviews = true;
		}
	} );

	$( window ).on( 'hashchange', updateCategory );
}

function initCategoryPreviews() {
	const category = getHashFilter();
	const initialCategory = getHashFilter() || $categoryPreviews.first().attr( 'data-category' );

	showActivePreview( initialCategory );
	updateNavFilters( initialCategory );

	// If coming from another page on the site go directlty to previews.
	if ( category !== null ) {
		scrollToPreviews( 0 );
	}
}

function init() {
	if ( !$body.hasClass( 'is-page-front' ) ) {
		return;
	}

	initCategoryPreviews();
	initEvents();
}

export default { init };
